import { client } from 'utilities/db';
import { useQuery } from 'react-query';

export const useFetchInventoryProductHook = (keyName = 'inventory', id) => {
  const { status, data, error, isFetching, isLoading, refetch } = useQuery(
    [keyName],
    () => getInventoryProductData(id),
    {
      enabled: !!id,
      refetchInterval: 60000
    }
  );

  return {
    inventoryStatus: status,
    inventoryData: data,
    inventoryError: error,
    inventoryFetching: isFetching,
    inventoryLoading: isLoading,
    inventoryRefetch: refetch
  };
};

const getInventoryProductData = async (id) => {
  let result = await client.get(`/inventory/findAllByProduct/${id}`);
  result = result.data;

  return result;
};
